import React, { useState, useEffect } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { MobileMenu } from "./MobileMenu";
import { getDefaultLang, langs } from "../../../utils";
import { MobileSelect } from "../../MobileSelect";

const defaultLang = getDefaultLang();
const setCookieLang = (lang) => {
  const topLevelDomain = window.location.hostname
    .split(".")
    .slice(-2)
    .join(".");
  document.cookie = `_authing_lang=${lang}; path=/; domain=${topLevelDomain}`;
};

export const MobileFooter = (props) => {
  const { menuList, communityLink } = props;
  let { i18n, t } = useTranslation();
  const [lang] = useState(defaultLang);
  const onOutLink = (path) => {
    window.location.href = path;
  };
  const change = (event) => {
    const _lang = event.target.value;
    i18n.changeLanguage(_lang);
    setCookieLang(_lang);
    window.location.reload();
  };
  useEffect(() => {
    i18n.changeLanguage(lang);
    setCookieLang(lang);
  }, [lang, i18n]);
  return (
    <div className="m-footer-container">
      <div className="m-footer-head">
        <div
          className="m-logo"
          onClick={() => {
            onOutLink("/");
          }}
        >
          <img
            src={"//files.authing.co/authing-website/authing-logo.png"}
            alt=""
          />
        </div>
      </div>
      <div className="m-footer-content">
        {menuList.map((item, idx) => {
          return <MobileMenu key={`mobile-menu-${idx}`} dataSource={item} />;
        })}
      </div>
      <div className="m-footer-other">
        <div className="item icons-link">
          {communityLink.map((item, index) => {
            if (item.type) {
              return (
                <div className="wechat-code">
                  <div key={index} className="icon-link">
                    <i className={item.icon}></i>
                  </div>
                  <div className="wechat-img">
                    <img
                      src="//files.authing.co/authing-website/wechat-code.jpg"
                      alt="authing"
                    />
                  </div>
                </div>
              );
            } else {
              return (
                <a
                  key={index}
                  className="icon-link"
                  href={item.path}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className={item.icon}></i>
                </a>
              );
            }
          })}
        </div>

        <div className="switch-lang">
          <MobileSelect options={langs} value={lang} onChange={change} />
        </div>

        <div className="item item-link">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://beian.miit.gov.cn/"
          >
            <span>{t("common.footer.footer-adress")}</span>
          </a>
        </div>
        <div className="item item-link">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035968"
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src="//files.authing.co/authing-website/icon-beian-gov.png"
              alt="beian"
            />
            <span>{t("common.footer.footer-beian")}</span>
          </a>
        </div>
        <div className="item comp">{t("common.footer.footer-copyright")}</div>
        <div className="item item-link">
          {t("common.footer.footer-friendly-link")}:
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.apifox.cn"
          >
            Apifox
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.showmebug.com"
          >
            ShowMeBug
          </a>
        </div>
        <div className="item item-link">
          <a target="_blank" rel="noopener noreferrer" href="https://code.fun">
            CodeFun
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href=" https://botorange.com"
          >
            {t("common.footer.footer-juzi")}
          </a>
        </div>
      </div>
    </div>
  );
};
